/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type StatusCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, state: Types.ConfigurationStatus };

export const StatusCell_ConfigurationFragmentDoc = gql`
    fragment StatusCell_configuration on ConfigurationModel {
  id
  state
}
    `;